import { cn } from "../utils"

interface SpinnerProps {
  className?: string
}

export function Spinner({ className }: SpinnerProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={cn("size-8 animate-spin text-muted-foreground", className)}>
      <path fill="currentColor" d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" />
    </svg>
  )
}
